export const ComponentsLoaderSymbol = Symbol('ComponentsLoader')
export const ComponentsRegistrarSymbol = Symbol('ComponentsRegistrar')
export const ComponentWrapperSymbol = Symbol('ComponentWrapper')
export const ComponentDidMountWrapperSymbol = Symbol('ComponentDidMountWrapperSymbol')
export const ExecuteComponentWrappersSymbol = Symbol('ExecuteComponentWrappers')
export const name = 'componentsLoader'
